import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import "./KisPersonFilter.scss";
export default {
  name: "KisPersonFilter",
  components: { TreeViewSelection },
  props: ["tasks", "subjectAreas", "departments", "value"],
  data: () => ({
    filter: {
      task: [],
      subjectArea: [],
      department: [],
      deleted: false
    },
    dialog: false
  }),
  async mounted() {},
  methods: {
    resetFilter() {
      this.filter = {
        task: [],
        subjectArea: [],
        department: [],
        deleted: false
      };
      this.$emit("filterChanged", this.filter);
    },
    addDepartment(department) {
      this.filter.department = department;
    },
    addSubjectArea(subjectArea) {
      this.filter.subjectArea = subjectArea;
    },
    addTask(task) {
      this.filter.task = task;
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    }
  }
};
